
import { NgModule } from '@angular/core';
import { TACharLimit } from 'src/commons/directives/CharLimit';
import { DisabledControlDirective } from 'src/commons/directives/DisableControl';
import { EINMask } from 'src/commons/directives/EINMask';
import { PhoneMask } from 'src/commons/directives/PhoneMask';
import { DecimalTrail } from 'src/commons/directives/TrailDecimal';
import { ZipCodeMask } from 'src/commons/directives/ZipCode';

@NgModule({
    imports: [],
    declarations: [PhoneMask, ZipCodeMask, TACharLimit, DecimalTrail, EINMask, DisabledControlDirective],
    entryComponents: [PhoneMask, ZipCodeMask, TACharLimit, DecimalTrail, EINMask, DisabledControlDirective],
    exports: [PhoneMask, ZipCodeMask, TACharLimit, DecimalTrail, EINMask, DisabledControlDirective]
})
export class AppCommonModule { }